
import request from '@/api/base'
// 查询管理员用户列表
const getContractFile = (params) => {
  // params.mockApi = true
  return request.post('/portal/contract/file/getContractFile', params)
}
const previewPdf = (params) => {
  // params.mockApi = true
  return request.get('/portal/images/tokenUrl', {params})
}
// 下载附件中的文件
const downloadAttachment = (params) => {
  return request.get(`/portal/images/tokenUrl`, {params})
}
// 请求文件流
const getFile = (url) => {
  return request.get(url)
}
// const getPdfUrl = (contractId) => {
//   let url
//   let params = {
//     contractId
//   }
//   getContractFile(params).then(data => {
//     if (data.errorMessage) {
//       this.$message.error(data.errorMessage)
//     } else {
//       let pdfUrl = data.body.pdfFile
//       if (pdfUrl) {
//         let params = {
//           fileUrl: pdfUrl
//         }
//         previewPdf(params).then(res => {
//           if (res.errorMessage) {
//             this.$message.error(res.errorMessage)
//           } else {
//             url = res.body
//             console.log(url)
//           }
//         })
//       }
//     }
//   })
//   if (url) { console.log(url) }

//   return url
// }
export default {
  getContractFile,
  previewPdf,
  downloadAttachment,
  getFile
}



// WEBPACK FOOTER //
// ./src/area-contract/api/contractDownload.js